// src/hooks/useSessionTimeout.js
// Vigila la expiración del token SAP (30 min por defecto). Cuando vence:
//   1. Notifica al usuario con un toast.
//   2. Cierra la sesión (limpia localStorage).
//   3. Redirige a /login.
// Debe usarse dentro del árbol del Router y del ToastProvider.
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../components/Toast/ToastProvider';
import { getSessionExpiry, clearSession } from './useAuth';

export const useSessionTimeout = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const timerRef = useRef(null);

  useEffect(() => {
    const expira = getSessionExpiry();

    const cerrarPorVencimiento = () => {
      clearSession();
      showToast(
        'Tu sesión expiró por seguridad (30 min). Por favor, inicia sesión nuevamente.',
        'warning',
        7000
      );
      navigate('/login', { replace: true });
    };

    // Sin marca de expiración: nada que vigilar.
    if (!expira) return;

    const restante = expira - Date.now();

    if (restante <= 0) {
      // Ya venció (p. ej. la pestaña quedó abierta o se recargó tarde).
      cerrarPorVencimiento();
      return;
    }

    timerRef.current = setTimeout(cerrarPorVencimiento, restante);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [navigate, showToast]);
};

export default useSessionTimeout;
